// extracted by mini-css-extract-plugin
module.exports = {"gameHeader":"Header_gameHeader__3VADm"};